module.exports = __webpack_public_path__ + "static/media/bangalore-rmc.f7b554b3.png";